/** Route slug ↔ `/legal/criminal-law`. */
export const CRIMINAL_LAW_SLUG = "criminal-law";

export const criminalLawDefaultData = {
  heroImage:
    "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=1500&q=80",
  galleryImages: [
    "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1593115057324-ac3947970c15?auto=format&fit=crop&w=900&q=80",
  ],
  stats: [
    { value: "3+", label: "Rights Guides" },
    { value: "24h", label: "Expert Response" },
    { value: "48h", label: "Court Rule" },
  ],
  funnelTagline:
    "Education → clarity on arrest & bail → trust in process → speak to a criminal lawyer",
  focusAreas: ["Bail processes", "Legal defense", "Arrest rights", "Court representation"],
  primaryCtaHeading: "Talk to a criminal lawyer",
  introduction: {
    headline: "WHY CRIMINAL LAW MATTERS IN GHANA",
    lead: "Criminal law affects every Ghanaian, whether directly or indirectly.",
    bullets: ["You may be arrested", "You may be accused wrongly", "You may need to defend yourself or someone else"],
    pointerLead: "Many people panic because they don’t understand their rights.",
    leadsToHeading: "This leads to:",
    leadsTo: ["Wrongful decisions", "Unnecessary detention", "Poor legal outcomes"],
    closing: "Understanding your rights can protect your freedom.",
  },
  whatIs: {
    title: "WHAT IS CRIMINAL LAW IN GHANA",
    dealsWithHeading: "Criminal law deals with:",
    dealsWith: ["Offences (crimes)", "Investigation", "Arrest", "Trial", "Punishment"],
    governedHeading: "It is governed mainly by:",
    governed: ["1992 Constitution of Ghana", "Criminal Offences Act (Act 29)", "Criminal Procedure Code (Act 30)"],
    dualLead: "These laws ensure both:",
    dual: ["Justice for victims", "Protection for accused persons"],
  },
  arrest: {
    title: "ARREST IN GHANA (WHAT YOU MUST KNOW)",
    warrantHeading: "Can You Be Arrested Without a Warrant?",
    warrantLead: "Yes.",
    warrantSub: "You can be arrested:",
    whoCanArrest: ["By police", "By a private citizen (in some cases)", "By a judge or legal authority"],
    rightsHeading: "Your Rights When Arrested",
    rights: [
      "Be told why you are being arrested",
      "Remain silent",
      "Contact a lawyer",
      "Be treated with dignity",
      "Be brought before court within 48 hours",
    ],
    ruleHeading: "Important Rule",
    ruleBody:
      "You cannot be detained beyond 48 hours without being taken to court unless properly processed.",
    whatToDoHeading: "What To Do If Arrested",
    whatToDo: ["Stay calm", "Do not resist arrest", "Ask for the reason", "Request a lawyer immediately", "Avoid making statements without legal advice"],
  },
  bail: {
    title: "BAIL PROCESS IN GHANA (VERY IMPORTANT)",
    whatHeading: "What is Bail?",
    whatBody:
      "Bail allows you to be temporarily released from custody while your case continues.",
    typesHeading: "Types of Bail in Ghana",
    types: [
      {
        number: 1,
        title: "Police Enquiry Bail",
        body: "Granted by police during investigation.",
      },
      {
        number: 2,
        title: "Court Bail (Pending Trial)",
        body: "Granted by a judge during trial.",
      },
      {
        number: 3,
        title: "Bail Pending Appeal",
        body: "After conviction (in some cases).",
      },
    ],
    howHeading: "How Bail Works",
    howMayNeed: ["A surety (guarantor)", "A bail amount", "Proof of residence or employment"],
    howFootnote: "Bail is not automatic — it depends on the case.",
    ruleHeading: "Important Rule",
    ruleBody: "Bail conditions must not be unreasonable or punitive.",
    difficultHeading: "When Bail May Be Difficult",
    difficult: ["Serious offences", "Risk of escape", "Interference with investigation"],
  },
  legalDefense: {
    title: "LEGAL DEFENCE (YOUR PROTECTION)",
    whyHeading: "Why Legal Defence Matters",
    whyBullets: ["Your rights are protected", "You receive a fair trial", "Proper procedures are followed"],
    rightsHeading: "Your Legal Rights",
    legalRights: [
      "Legal representation at all stages",
      "A fair and public trial",
      "Be informed of charges clearly",
    ],
    mistakeHeading: "Common Mistake",
    mistakeBody:
      "Talking to police without a lawyer — this can harm your case.",
  },
  courtProcess: {
    title: "COURT PROCESS IN GHANA (WHAT HAPPENS NEXT)",
    afterArrestHeading: "After Arrest",
    afterArrestSteps: ["Investigation begins", "You may be granted bail or detained", "Case is filed in court"],
    stagesHeading: "Court Stages",
    stages: [
      "First appearance (arraignment)",
      "Charges are read",
      "Bail considered",
      "Trial begins",
      "Judgment delivered",
    ],
    courtsHeading: "Types of Courts",
    courts: ["District Court (minor cases)", "Circuit Court", "High Court (serious offences)"],
  },
  trialRights: {
    title: "YOUR RIGHTS DURING TRIAL",
    rights: [
      "Be heard",
      "Present evidence",
      "Cross-examine witnesses",
      "Appeal decisions",
    ],
    principleHeading: "Important Principle",
    principleQuote: "You are presumed innocent until proven guilty.",
  },
  commonIssues: {
    title: "COMMON CRIMINAL LAW ISSUES IN GHANA",
    intro: "Top situations people face",
    items: ["Wrongful arrest", "Difficulty getting bail", "Police intimidation", "Lack of legal representation", "Delays in court cases"],
  },
  practicalTips: {
    title: "PRACTICAL TIPS FOR GHANAIANS",
    ifArrested: {
      heading: "If Arrested",
      items: ["Do not panic", "Ask for a lawyer immediately", "Do not sign documents you don’t understand"],
    },
    ifHelping: {
      heading: "If Helping Someone Arrested",
      items: ["Get legal representation quickly", "Follow bail procedures", "Gather documents"],
    },
    duringProcess: {
      heading: "During Legal Process",
      items: ["Attend court dates", "Respect bail conditions", "Keep communication with lawyer"],
    },
  },
  redFlags: {
    title: "RED FLAGS TO WATCH OUT FOR",
    items: [
      "Being detained beyond 48 hours without court",
      "Police refusing access to a lawyer",
      "Signing statements under pressure",
      "Unofficial payments for bail",
      "Not understanding charges",
    ],
  },
  editorialPlaybook: {
    title: "HIGH-CONVERTING INFOBOXX CONTENT IDEAS",
    articlesHeading: "Articles",
    articles: [
      "“What To Do If You Are Arrested in Ghana”",
      "“How Bail Works in Ghana (Simple Guide)”",
      "“Know Your Rights During Police Arrest”",
    ],
    videosHeading: "Videos",
    videos: ["Bail process explained", "Arrest rights breakdown", "Court process overview"],
    leadCtasHeading: "CTA options",
    leadCtas: [
      "Talk to a criminal lawyer",
      "Get bail assistance",
      "Book legal consultation",
      "Defend your case",
    ],
  },
  funnelApplication: {
    title: "INFOBOXX FUNNEL APPLICATION",
    hook: { label: "Hook", text: "“What should I do if I am arrested?”" },
    education: { label: "Education", text: "Explain rights + bail + process" },
    authority: { label: "Authority", text: "Legal framework + procedures" },
    conversion: { label: "Conversion", text: "“Speak to a criminal lawyer now”" },
  },
  scenario: {
    title: "REAL-LIFE SCENARIO",
    eyebrow: "High engagement example",
    exampleLead: "You are arrested at night:",
    bullets: ["Police must inform you why", "You can request a lawyer", "You must be taken to court within 48 hours"],
    outcomesHeading: "Possible outcomes:",
    outcomes: ["Police bail", "Court bail", "Remand (if serious case)"],
  },
  finalTakeaway: {
    title: "FINAL TAKEAWAY",
    bullets: [
      "Being arrested does not mean you are guilty",
      "You have rights that must be respected",
      "Legal guidance can change the outcome of your case",
    ],
  },
  bottomLine: {
    title: "BOTTOM LINE",
    lead: "The difference between:",
    smooth: "Freedom and detention · winning your case",
    and: "and",
    stressful: "Unnecessary detention · poor outcomes",
    closing: "…is knowing your rights and getting legal help early.",
  },
  faqs: [
    {
      q: "Can I be arrested in Ghana without a warrant?",
      a: "Yes, in several situations — including by police, in some circumstances by private citizens acting lawfully, or by lawful authority such as a court. Knowing your rights immediately after arrest is critical.",
    },
    {
      q: "Does the Constitution say anything about detention after arrest?",
      a: "Accused persons are generally entitled to be brought before a court promptly. Practical guidance emphasizes not being detained beyond reasonable timeframes without lawful process — your lawyer can challenge unlawful detention.",
    },
    {
      q: "What kinds of bail exist in Ghana?",
      a: "Common categories include police enquiry bail during investigation, court bail pending trial, and bail pending appeal in permitted cases. Each depends on facts, seriousness, risk, and conditions set by authorities.",
    },
    {
      q: "Should I speak to police without a lawyer?",
      a: "It is a common mistake. You have rights such as contacting counsel and weighing whether to remain silent early in the process. Legal advice protects you against statements that harm your defence.",
    },
    {
      q: "What courts hear criminal matters?",
      a: "Serious cases may go through High Court pathways; lesser matters may begin in District or Circuit courts depending on the offence and procedure. Representation helps you navigate summons, charges, bail, and trial timelines.",
    },
  ],
  articles: [
    {
      id: "cl-a-1",
      slug: "criminal-law-what-to-do-if-arrested-ghana",
      title: "What To Do If You Are Arrested in Ghana",
      excerpt:
        "Stay calm, ask why you’re arrested, request a lawyer, know the 48-hour rule, avoid harmful statements — and why early legal help matters.",
      type: "Guide",
      readTime: "9 min read",
      author: "InfoBoxx Editorial Desk",
      publishedAt: "Updated recently",
      updatedAt: "Updated recently",
      socialText: 'Read: "What To Do If You Are Arrested in Ghana"',
      coverImage:
        "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=800&q=80",
      tags: ["Arrest", "Rights", "Ghana"],
      pullQuote:
        "Being arrested does not mean you are guilty — know your rights and get legal guidance early.",
      takeaways: [
        "Remain calm and confirm the basis for arrest",
        "Request a lawyer before detailed statements",
        "Know bail and detention basics",
      ],
      video: {
        title: "Arrest rights breakdown",
        duration: "5:10",
        poster:
          "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=800&q=80",
      },
      body: [
        {
          heading: "Why Criminal Law Matters to Everyone",
          text: "You may face arrest personally, help someone in custody, or need to understand court processes affecting your household.",
          bullets: [
            "Know your constitutional and statutory safeguards",
            "Avoid panic-led mistakes",
          ],
        },
        {
          heading: "Your Immediate Steps After Arrest",
          bullets: [
            "Stay calm and do not resist unlawfully beyond what law allows",
            "Ask for reasons for arrest",
            "Request a lawyer as soon as possible",
            "Avoid informal statements until advised",
          ],
        },
        {
          heading: "48 Hours Detention Awareness",
          text: "Authorities must follow lawful timelines and processes. Raise concerns promptly with counsel if detention appears irregular.",
        },
        {
          heading: "Rights Checklist",
          bullets: ["Reason for arrest", "Silence consideration", "Dignified treatment", "Court access timelines"],
        },
      ],
    },
    {
      id: "cl-a-2",
      slug: "criminal-law-bail-explained-ghana",
      title: "How Bail Works in Ghana (Simple Guide)",
      excerpt:
        "Police bail, court bail, sureties, conditions, when bail gets harder — and why conditions must not be unreasonable or punitive.",
      type: "Checklist",
      readTime: "8 min read",
      author: "Partner Knowledge Team",
      publishedAt: "This week",
      updatedAt: "This week",
      socialText: 'Read: "How Bail Works in Ghana (Simple Guide)"',
      coverImage:
        "https://images.unsplash.com/photo-1593115057324-ac3947970c15?auto=format&fit=crop&w=800&q=80",
      tags: ["Bail", "Courts", "Procedure"],
      pullQuote:
        "Bail is temporary release tied to lawful conditions — preparation and representation improve outcomes.",
      takeaways: [
        "Understand type of bail you’re seeking",
        "Gather residence and employment evidence",
        "Respect lawful conditions strictly",
      ],
      video: {
        title: "Bail process explained",
        duration: "4:40",
        poster:
          "https://images.unsplash.com/photo-1563986768494-de4b277cdd52?auto=format&fit=crop&w=800&q=80",
      },
      body: [
        {
          heading: "What Bail Is",
          text: "Bail temporarily releases someone from custody while a case proceeds, subject to conditions.",
        },
        {
          heading: "Types Overview",
          bullets: [
            "Police enquiry bail",
            "Court bail pending trial",
            "Bail pending appeal where applicable",
          ],
        },
        {
          heading: "What You Might Need",
          bullets: ["Surety", "Bail bond or amount as directed", "Proof of ties to community"],
        },
        {
          heading: "When Bail Is Tougher",
          bullets: ["Serious charges", "Flight risk indicators", "Interference risks with witnesses or probes"],
        },
      ],
    },
    {
      id: "cl-a-3",
      slug: "criminal-law-rights-during-arrest-police-interaction",
      title: "Know Your Rights During Police Arrest",
      excerpt:
        "Acts 29 & 30, constitutional protections, fair trial pillars, presumption of innocence — and documenting red flags.",
      type: "Expert Explainer",
      readTime: "7 min read",
      author: "Consumer Guidance Unit",
      publishedAt: "Reviewed this month",
      updatedAt: "Reviewed this month",
      socialText: 'Read: "Know Your Rights During Police Arrest"',
      coverImage:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
      tags: ["Constitution", "Representation", "Procedure"],
      pullQuote:
        "Framework exists for both victims and accused — balance starts with respecting procedure.",
      takeaways: [
        "Representation at all stages",
        "Charges clearly articulated",
        "Appeal avenues where lawful",
      ],
      video: {
        title: "Court process overview",
        duration: "6:05",
        poster:
          "https://images.unsplash.com/photo-1521791055364-18956bb5568e?auto=format&fit=crop&w=800&q=80",
      },
      body: [
        {
          heading: "Governing Framework Snapshot",
          bullets: ["Constitution protections", "Criminal Procedure Code contours", "Criminal offences definitions"],
        },
        {
          heading: "Defence Perspective",
          text: "Your lawyer safeguards procedure, advises on disclosures, prepares evidence strategy, and challenges irregularities.",
        },
        {
          heading: "Red Flags to Escalate",
          bullets: [
            "Denied lawyer access unusually",
            "Pressure to sign without understanding",
            "Requests for unofficial payments",
          ],
        },
      ],
    },
  ],
  videos: [
    {
      id: "cl-v-1",
      title: "Bail process explained",
      duration: "4:40",
      poster:
        "https://images.unsplash.com/photo-1563986768494-de4b277cdd52?auto=format&fit=crop&w=800&q=80",
      description: "Police vs court bail, sureties, and how conditions ought to operate fairly.",
    },
    {
      id: "cl-v-2",
      title: "Arrest rights breakdown",
      duration: "5:10",
      poster:
        "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=800&q=80",
      description: "What happens at arrest, reminders on silence strategy, dignity, and timelines.",
    },
    {
      id: "cl-v-3",
      title: "Court process overview",
      duration: "6:05",
      poster:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
      description: "From filing to plea, bail junctures, trial, and avenues after judgment.",
    },
  ],
  podcasts: [
    {
      id: "cl-p-1",
      episodeLabel: "Episode 1",
      duration: "29 min",
      title: "Arrest Nights: Rights in the First 48 Hours",
      description: "What families should rehearse before a worst-case knock at the door.",
      host: "Afrimore Legal Desk",
      publishedAt: "May 2026",
      coverImage:
        "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: "cl-p-2",
      episodeLabel: "Episode 2",
      duration: "33 min",
      title: "Bail Strategy with Junior & Senior Courts",
      description: "Practical dossiers lawyers assemble for sureties and risk arguments.",
      host: "Consumer Guidance Unit · Infoboxx",
      publishedAt: "April 2026",
      coverImage:
        "https://images.unsplash.com/photo-1593115057324-ac3947970c15?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: "cl-p-3",
      episodeLabel: "Mini",
      duration: "19 min",
      title: "From Charge Sheet to Closing Argument",
      description: "Staged expectations for defendants and sponsors supporting someone on trial.",
      host: "Afrimore Legal Desk",
      publishedAt: "March 2026",
      coverImage:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
    },
  ],
};
